module.exports = __webpack_public_path__ + "img/icon-selection-hall-bg.74b9c000.png";